<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_18169_44680)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.4292 0.732198C7.4292 0.327819 7.75701 0 8.16141 0H11.2678C11.6722 0 12 0.327819 12 0.732198V3.83864C12 4.24302 11.6722 4.57084 11.2678 4.57084C10.8635 4.57084 10.5356 4.24302 10.5356 3.83864V2.49972L6.60805 6.42734C6.32216 6.71329 5.85854 6.71329 5.57259 6.42734C5.28664 6.14139 5.28664 5.67776 5.57259 5.39188L9.49998 1.4644H8.16141C7.75701 1.4644 7.4292 1.13658 7.4292 0.732198ZM2.19656 0.650951C0.983435 0.650951 0 1.6344 0 2.84754V9.80344C0 11.0166 0.983435 12 2.19656 12H9.15233C10.3655 12 11.3489 11.0166 11.3489 9.80344V6.87459C11.3489 6.47026 11.0211 6.14245 10.6167 6.14245C10.2124 6.14245 9.88454 6.47026 9.88454 6.87459V9.80344C9.88454 10.2078 9.55673 10.5356 9.15233 10.5356H2.19656C1.79219 10.5356 1.46437 10.2078 1.46437 9.80344V2.84754C1.46437 2.44316 1.79219 2.11535 2.19656 2.11535H5.12527C5.52967 2.11535 5.85748 1.78753 5.85748 1.38315C5.85748 0.978769 5.52967 0.650951 5.12527 0.650951H2.19656Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_18169_44680">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
